const BackToTop = () => {
	const backToTop = document.querySelector('.back-to-top-wrapper');

	if (window.scrollY > 300) {
		backToTop.classList.add('show');
	} else {
		backToTop.classList.remove('show');
	}
};

export default BackToTop;
